import { render, staticRenderFns } from "./Statistics_Suggestions.vue?vue&type=template&id=2be29baf&scoped=true&"
import script from "./Statistics_Suggestions.vue?vue&type=script&lang=js&"
export * from "./Statistics_Suggestions.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_Suggestions.vue?vue&type=style&index=0&id=2be29baf&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be29baf",
  null
  
)

export default component.exports